import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { reloadUserProfile } from '../../containers/UserProfile/actions';
import { HEAP_EVENTS, trackEvent } from '../../utils/Analytics';

let hasListener = false;

export const useGumroadListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (hasListener) {
      return () => {
        // Empty
      };
    }

    const listener = (event: any) => {
      try {
        const data = JSON.parse(event.data);
        const parentMethod = data.parentMethod;
        const postMessageName = data && data.post_message_name;

        // sale is event's name from Gumroad doc
        if (postMessageName === 'sale') {
          trackEvent(HEAP_EVENTS.subscriptionSuccess, {});
        }

        if (parentMethod === 'minimizeIframe') {
          dispatch(reloadUserProfile());
        }
      } catch (error) {
        // empty
      }
    };

    window.addEventListener('message', listener, false);

    hasListener = true;

    return () => {
      window.removeEventListener('message', listener);
      hasListener = false;
    };
  }, []);
};



// WEBPACK FOOTER //
// ./src/components/MembershipSettings/useGumroadListener.ts